export default __webpack_public_path__ + "static/media/toytrain.40847c93.png";